import React from 'react';
import { observer } from 'mobx-react';
import { NikoPatientListTemplate } from 'themes/application/niko-patient/pages';
import { setCurrentView } from 'core/utils';
import { NikoPatientListViewStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore) => new NikoPatientListViewStore(rootStore), 'nikoPatientListViewStore')
@observer
class NikoPatientList extends React.Component {
    render() {
        return <NikoPatientListTemplate {...this.props} />
    }
}

export default NikoPatientList;